import { createReduxHistoryContext } from 'redux-first-history'
import { createBrowserHistory } from 'history'

const history = createBrowserHistory() // Create only one history instance

const historyContext = createReduxHistoryContext({
  history,
  savePreviousLocations: 2
})

export const createReduxHistory = historyContext.createReduxHistory
export const routerMiddleware = historyContext.routerMiddleware
export const routerReducer = historyContext.routerReducer

// Access the initial location correctly
export const initialLocation = history.location
export const currentLocation = initialLocation?.pathname || ''

// Define employer-side routes properly
const employerRoutes = [
  '/dashboard/employerLogin',
  '/dashboard/employerRegister',
  '/dashboard/lightEntrepreneurs',
  '/dashboard/assignments',
  '/dashboard/applications',
  '/dashboard/workshifts',
  '/dashboard/companyProfile',
  '/dashboard/callback_employer',
  '/dashboard/contract'
]

export const employerSide = employerRoutes.includes(currentLocation)
